<template>
  <article class="list-container">
    <Button class="top-create--btn" type="primary" @click="showConfKeyPropertiesModal('add')">
      {{ $t(`${addBtnText}`) }}
    </Button>

    <Table :loading="loading" :columns="columns" :data="confKeyList"></Table>

    <ConfKeyPeopertiesModal
      ref="confKeyPropertiesRef"
      :modalVisible.sync="confKeyPropertiesVisible"
      :title="modalTitle"
      :category="category"
      :type="editConfKeyData.type"
      :confKeyName="editConfKeyData.name"
      :isEdit="isEditConfKey"
      :isCanAdvanced="category === RESOURCE_TYPE.sinks"
      :isShowConnectionSelector="category === RESOURCE_TYPE.sources"
      @submit="submitedConfKey"
    />
  </article>
</template>

<script>
import nodeID from '@/mixins/nodeID'
import ConfKeyPeopertiesModal from '@/views/configuration/resource/components/ConfKeyPropertiesModal.vue'
import { deleteSourceConfKey } from '@/api/metadata'
import { RESOURCE_TYPE } from '@/utils/constants'

export default {
  name: 'SourceConfKey',
  mixins: [nodeID],

  props: {
    confKeyList: { type: Array, default: () => [] },
  },

  components: {
    ConfKeyPeopertiesModal,
  },

  data() {
    return {
      RESOURCE_TYPE,
      category: RESOURCE_TYPE.sources,
      loading: false,
      columns: [
        {
          title: this.$t('common.name'),
          key: 'name',
        },
        {
          title: this.$t('common.type'),
          key: 'type',
        },
        {
          title: this.$t('common.operations'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return (
              <div>
                <a
                  style="margin-right: 10px;"
                  href="javascript:;"
                  onClick={() => {
                    this.showConfKeyPropertiesModal('edit', params.row)
                  }}
                >
                  <Icon type="ios-create"></Icon>
                </a>
                <a href="javascript:;">
                  <Poptip
                    confirm={true}
                    transfer={true}
                    width={200}
                    title={this.$t('common.confirmDelete')}
                    placement="top"
                    type="error"
                    vOn:on-ok={() => {
                      this.removeConfKey(params.row)
                    }}
                    vOn:on-cancel={() => {}}
                  >
                    <Icon type="md-trash"></Icon>
                  </Poptip>
                </a>
              </div>
            )
          },
        },
      ],
      isEditConfKey: false,
      confKeyPropertiesVisible: false,
      editConfKeyData: {},
    }
  },

  computed: {
    addBtnText() {
      return this.category === RESOURCE_TYPE.sources
        ? 'configuration.addSourceConfKey'
        : 'configuration.addSinkTemplate'
    },
    modalTitle() {
      return !this.isEditConfKey
        ? this.$t('configuration.addSourceConfKey')
        : this.$t('configuration.editSourceConfKey')
    },
  },

  methods: {
    showConfKeyPropertiesModal(oper, data) {
      this.isEditConfKey = oper === 'edit'
      this.editConfKeyData = data || {}
      this.confKeyPropertiesVisible = true
    },

    // remove conf key
    removeConfKey(row) {
      const { name, type } = row
      deleteSourceConfKey(this.nodeID, type, name).then(() => {
        this.$emit('reload')
      })
    },

    // edit | add conf key
    submitedConfKey() {
      this.$emit('reload')
    },
  },
}
</script>

<style lang="scss" scoped>
.list-container {
  margin-top: -32px;
}
</style>
